import { Col, Row } from 'antd';

// import logoGBA from '../../../../assets/images/logo_gba.svg';
import FooterLanding from '../../FooterLanding';

const baseStyle = {
  alignItems: 'center',
  marginBottom: 20
};

export default function Footer() {
  const style = baseStyle;
  return (
    <div style={{ backgroundColor: 'white', padding: 20, paddingBottom: 0 }}>
      <Row gutter={[16, 16]} justify="space-between" style={style}>
        <Col>
          <FooterLanding />
        </Col>
        <Col>{/* <img src={logoGBA} height={50} /> */}</Col>
      </Row>
    </div>
  );
}
